<ng-dialog-header title="Cancel Comments"></ng-dialog-header>
<div mat-dialog-content>
  <form [formGroup]="formGroup">
    <mat-form-field appearance="outline" class="w-100" color="accent">
      <mat-label ngRequired>Reason</mat-label>
      <textarea formControlName="reason" matInput maxlength="1000" ngTrim rows="4" type="text"></textarea>
    </mat-form-field>
  </form>
</div>
<ng-dialog-footer class="d-flex justify-content-end w-100">
  <div class="d-flex justify-content-end w-100" dialog-actions>
    <button mat-stroked-button mat-dialog-close class="mx-3" color="warn" aria-label="Cancel Dialog Button">Cancel</button>
    <button mat-flat-button color="accent" [disabled]="!formGroup.valid" (click)="cancelDiversion.emit(formGroup.get('reason')!.value)"
            aria-label="OK Dialog Button">OK
    </button>
  </div>
</ng-dialog-footer>
